'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdLocalGasStation = function MdLocalGasStation(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30 16.6q0.7 0 1.2-0.4t0.4-1.2-0.4-1.2-1.2-0.4-1.2 0.4-0.4 1.2 0.4 1.2 1.2 0.4z m-10 0v-8.2h-10v8.2h10z m13-4.6q1.1 1.2 1.1 3v15.9q0 1.7-1.2 2.9t-2.9 1.2-2.9-1.2-1.2-2.9v-8.4h-2.5v12.5h-16.8v-26.6q0-1.4 1.1-2.4t2.3-1h10q1.3 0 2.3 1t1.1 2.4v11.6h1.6q1.3 0 2.3 1t1.1 2.4v7.5q0 0.7 0.4 1.1t1.2 0.5 1.2-0.5 0.4-1.1v-12.1q-0.7 0.3-1.6 0.3-1.7 0-2.9-1.2t-1.2-2.9q0-2.8 2.6-3.9l-3.5-3.5 1.8-1.7z' })
        )
    );
};

exports.default = MdLocalGasStation;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/local-gas-station.js
// module id = 1688
// module chunks = 168707334958949